import { Luggage } from "lucide-react";

// ─── "Deposito Bagagli" (luggage storage) shared metadata ───
// Used by both the public Welcome Book (GuestbookApp) and the admin editor
// (LuggageEditor). Orange accent to match the requested tile colour.
export const LUGGAGE_ACCENT = {
  icon: Luggage,
  color: "#EA580C",
  gradient: "linear-gradient(135deg,#FB923C 0%,#F97316 48%,#C2410C 100%)",
};

export const LUGGAGE_TITLE = {
  it: "Deposito Bagagli",
  en: "Luggage Storage",
  fr: "Consigne à Bagages",
  es: "Consigna de Equipaje",
  de: "Gepäckaufbewahrung",
};

export const LUGGAGE_SUBTITLE = {
  it: "Scopri dove lasciarli",
  en: "Find where to leave them",
  fr: "Où les déposer",
  es: "Dónde dejarlas",
  de: "Wo abgeben",
};

export const LUGGAGE_LABELS = {
  website:    { it: "Sito web",       en: "Website",       fr: "Site web",       es: "Sitio web",       de: "Webseite" },
  directions: { it: "Indicazioni",    en: "Directions",    fr: "Itinéraire",     es: "Cómo llegar",     de: "Route" },
  distance:   { it: "di distanza",    en: "away",          fr: "de distance",    es: "de distancia",    de: "entfernt" },
  convention: { it: "Convenzione",    en: "Special deal",  fr: "Partenariat",    es: "Convenio",        de: "Vereinbarung" },
  apps:       { it: "Scarica le App", en: "Download the Apps", fr: "Télécharger les Apps", es: "Descarga las Apps", de: "Apps herunterladen" },
  empty:      { it: "Nessun deposito configurato", en: "No storage configured", fr: "Aucune consigne configurée", es: "Sin consigna configurada", de: "Keine Aufbewahrung konfiguriert" },
};

// Format a distance in metres → "850 m" or "1.2 km"
export const fmtDistance = (m) => {
  const n = Number(m);
  if (!n || n <= 0) return "";
  if (n >= 1000) return `${(n / 1000).toFixed(n % 1000 === 0 ? 0 : 1)} km`;
  return `${Math.round(n)} m`;
};
